import React from 'react';
import PropTypes from 'prop-types';
// import ReactRouterPropTypes from 'react-router-prop-types';
import {
  KeyboardAvoidingView,
  View,
} from 'react-native';
import {
  Button, Input, Text,
} from 'react-native-elements';
import { Formik } from 'formik';
import { object as yupObject } from 'yup';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

import AORTypes from '../../../types';
import Breadcrumb from '../../../../vendor/react-native-breadcrumb';
import { translate } from '../../../locales/i18n';
import styles from '../../../styles';
import stylesPublisher from '../../../styles/create';
import {
  guideNameValidation,
  guideDescValidation,
} from '../../../modules/validation/App';
import MyPublisherBadge from '../../apps/MyPublisherBadge';
import Publisher from '../../../modules/data/Publisher';
import App from '../../../modules/data/App';

const validationSchema = yupObject().shape({
  guideName: guideNameValidation,
  guideDesc: guideDescValidation,
});

class PublisherAppFormGuide extends React.Component {
  static getDerivedStateFromProps(props, state) {
    if (props.userData.image !== null && props.userData.image !== state.publisher.data.image) {
      const publisher = Publisher.createFromApp(props.app, props.userData);
      publisher.data.image = props.userData.image;

      console.log('getDerivedStateFromProps');
      console.log('props.app');
      console.log(props.app);
      console.log('publisher');
      console.log(publisher);
      console.log('props.userData');
      console.log(props.userData);

      return {
        publisher,
      };
    }

    return null;
  }

  constructor(props, context) {
    super(props, context);

    this.handleCancel = this.handleCancel.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleNext = this.handleNext.bind(this);

    const { app, userData } = this.props;

    const publisher = Publisher.createFromApp(app, userData);

    console.log('constructor');
    console.log('app');
    console.log(app);
    console.log('publisher');
    console.log(publisher);
    console.log('userData');
    console.log(userData);

    this.state = {
      publisher,
    };
  }

  handleCancel() {
    const { onCancel } = this.props;

    onCancel();
  }

  handleBack(values) {
    const { onSave, onPageSwitch } = this.props;

    onSave(values);
    onPageSwitch(1);
  }

  async handleNext(values, formikBag) {
    const {
      onSave,
      onPageSwitch,
      getAnalyticsService,
    } = this.props;

    formikBag.setSubmitting(true);
    const err = await onSave(values);
    if (err !== null) {
      getAnalyticsService().report.event('page2SaveError', 'create');
      formikBag.setStatus(err);
    } else {
      getAnalyticsService().report.event('page2SaveSuccess', 'create');
    }
    formikBag.setSubmitting(false);

    console.log('err');
    console.log(err);
    if (err === null) {
      onPageSwitch(3);
    }
  }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
    status,
  }) => {
    const {
      onPageSwitch, user, updateUserData, getUploader,
      onAddUserImage,
      direction,
    } = this.props;
    const { publisher } = this.state;

    return (
      <>
        <Breadcrumb
          entities={[
            translate('create_app_app'),
            translate('create_app_guide'),
            translate('create_app_endpoints'),
            translate('create_app_payment'),
            translate('create_app_links'),
            translate('create_app_review'),
          ]}
          isTouchable
          flowDepth={1}
          onCrumbPress={(index) => onPageSwitch(index + 1)}
          borderRadius={3}
          firstCrumbStyle={stylesPublisher.publisherAppEdit.firstCrumbStyle}
          crumbsContainerStyle={direction === 'column' ? stylesPublisher.publisherAppEdit.crumbsContainerStyle : stylesPublisher.publisherAppEdit.crumbsContainerStyleLandscape}
        />
        {/* Page 2: Guide Info */}
        <KeyboardAvoidingView
          style={[
            styles.view.form,
            {
              backgroundColor: 'white',
              width: '100%',
              padding: 0,
              margin: 0,
              alignItems: 'center',
              justifyContent: 'space-evenly',
            },
          ]}
          behavior="padding"
        >
          <KeyboardAwareScrollView
            style={{
              flex: 1,
              width: '100%',
              maxWidth: 600,
              alignSelf: 'center',
              margin: 0,
            }}
            contentContainerStyle={{
              width: '100%',
              padding: 0,
              alignItems: 'center',
              justifyContent: 'space-evenly',
              paddingBottom: 20,
            }}
            enableAutomaticScroll={false}
          >
            {status !== undefined && (
              <Text
                style={{
                  color: 'red',
                }}
              >
                {status}
              </Text>
            )}
            <View style={{ width: '80%' }}>
              <View
                style={{
                  maxWidth: 500,
                  height: 74,
                  minHeight: 74,
                  maxHeight: 74,
                  marginVertical: 20,
                }}
              >
                <MyPublisherBadge
                  user={user}
                  userData={publisher.data}
                  publisher={publisher}
                  onAddUserImage={onAddUserImage}
                  updateUserData={updateUserData}
                  getUploader={getUploader}
                // redirect="addapp"
                />
              </View>
            </View>
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={styles.form.inputLabel}
              inputStyle={styles.form.inputInput}
              inputContainerStyle={touched.guideName && errors.guideName ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              label={`${translate('app_guide_name')}:`}
              value={values.guideName}
              placeholder={translate('app_guide_name_placeholder')}
              // autoCapitalize="none"
              // autoFocus
              onChangeText={(value) => { setFieldValue('guideName', value); publisher.data.name = value; }}
              onBlur={() => setFieldTouched('guideName')}
              errorMessage={touched.guideName && errors.guideName ? errors.guideName : undefined}
            />
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={styles.form.inputLabel}
              inputStyle={[styles.form.inputInput, { paddingVertical: 10 }]}
              inputContainerStyle={touched.guideDesc && errors.guideDesc ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              label={`${translate('app_guide_about')}:`}
              value={values.guideDesc}
              placeholder={translate('app_guide_about_placeholder')}
              // autoCapitalize="none"
              multiline
              numberOfLines={4}
              onChangeText={(value) => {
                setFieldValue('guideDesc', value);
                publisher.pp.desc[publisher.lang] = value;
                publisher.data.desc = JSON.stringify(publisher.pp.desc);
              }}
              onBlur={() => setFieldTouched('guideDesc')}
              errorMessage={touched.guideDesc && errors.guideDesc ? errors.guideDesc : undefined}
            />
          </KeyboardAwareScrollView>
        </KeyboardAvoidingView>
        <View style={styles.form.containerButtons}>
          <Button
            title={translate('button_cancel')}
            containerStyle={styles.button.secondaryContainer}
            buttonStyle={styles.button.secondary}
            disabledStyle={styles.button.secondaryDisabled}
            titleStyle={styles.button.secondaryTitle}
            disabledTitleStyle={styles.button.secondaryTitleDisabled}
            onPress={this.handleCancel}
          />
          <Button
            title={translate('button_prev')}
            containerStyle={styles.button.primaryContainer}
            buttonStyle={styles.button.primary}
            disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={() => this.handleBack(values)}
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
            loadingProps={{ size: 'small', color: 'white' }}
          />
          <Button
            title={translate('button_next')}
            containerStyle={styles.button.primaryContainer}
            buttonStyle={styles.button.primary}
            disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={handleSubmit}
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
            loadingProps={{ size: 'small', color: 'white' }}
          />
        </View>
      </>
    );
  };

  render() {
    const { app } = this.props;
    const { publisher } = this.state;

    console.log('render');
    console.log('app');
    console.log(app);
    console.log('publisher');
    console.log(publisher);

    return (
      <Formik
        validateOnMount
        enableReinitialize
        initialValues={{
          guideName: publisher.data.name,
          guideDesc: publisher.pp.desc[publisher.lang],
          year: app.data.year || 2020,
        }}
        onSubmit={(values, formikBag) => this.handleNext(values, formikBag)}
        validationSchema={validationSchema}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

PublisherAppFormGuide.defaultProps = {
  userData: {},
};

PublisherAppFormGuide.propTypes = {
  user: AORTypes.AWS.Cognito.User.isRequired,
  userData: AORTypes.User,
  onAddUserImage: PropTypes.func.isRequired,
  updateUserData: PropTypes.func.isRequired,
  app: PropTypes.instanceOf(App).isRequired,
  onCancel: PropTypes.func.isRequired,
  onPageSwitch: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  getUploader: PropTypes.func.isRequired,
  // history: ReactRouterPropTypes.history.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  direction: PropTypes.string.isRequired,
};

export default PublisherAppFormGuide;
